import TicketMint from '~/shared/assets/images/ticket-mint.png'
import TicketPink from '~/shared/assets/images/ticket-pink.png'
import TicketPurple from '~/shared/assets/images/ticket-purple.png'
import TicketMintMobile from '~/shared/assets/images/ticket-vertical-mint.png'
import TicketPinkMobile from '~/shared/assets/images/ticket-vertical-pink.png'
import TicketPurpleMobile from '~/shared/assets/images/ticket-vertical-purple.png'
import TicketYellowMobile from '~/shared/assets/images/ticket-vertical-yellow.png'
import TicketYellow from '~/shared/assets/images/ticket-yellow.png'

export const getTicketBackgroundImage = (type: string, isMobile: boolean) => {
  switch (type) {
    case 'E0200001':
      return isMobile ? TicketMintMobile : TicketMint
    case 'E0200002':
      return isMobile ? TicketYellowMobile : TicketYellow
    case 'E0200003':
      return isMobile ? TicketPinkMobile : TicketPink
    case 'E0200004':
      return isMobile ? TicketMintMobile : TicketMint
    default:
      return isMobile ? TicketPurpleMobile : TicketPurple
  }
}
